import React from 'react';
import { DefaultFieldLayout } from '../../../../field-layout';
import { createFormFields } from './create-form-fields';
import { useFormFields } from '../../contexts/form-fields-context';
import { FormFieldsContext } from '../../../../contexts/form-fields-context';
export const Group = _ref => {
  let {
    field,
    errors,
    values,
    FieldLayout,
    onFieldChange = () => {}
  } = _ref;
  const componentsById = useFormFields();
  const GroupComponent = componentsById.GROUP;
  if (!GroupComponent) {
    return null;
  }
  const groupedElements = createFormFields({
    fields: field.groupedFields,
    values,
    errors,
    onFieldChange,
    FieldLayout: DefaultFieldLayout
  });
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: field.id
  }, /*#__PURE__*/React.createElement(FormFieldsContext.Provider, {
    value: field.groupedFields
  }, /*#__PURE__*/React.createElement(GroupComponent, {
    id: field.id,
    fieldType: field.fieldType,
    FieldLayout: FieldLayout,
    groupedFields: groupedElements,
    gridColumns: field.layout.width
  })));
};
//# sourceMappingURL=group.js.map